import API from "apiInstance";
import { toast } from "react-toastify";

export const createProject = async (body) => {
  try {
    const response = await API({
      method: "post",
      url: "/api/project/create-project",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};

export const projectUpdate = async (body) => {
  try {
    const response = await API({
      method: "post",
      url: "/api/project/update",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};

export const getNgoProjects = async () => {
  try {
    const response = await API({
      method: "get",
      url: "/api/project/all",
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const getSingleProject = async ({ projectId }) => {
  try {
    const response = await API({
      method: "get",
      url: `/api/project/project/${projectId}`,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const getAllProjectsCount = async () => {
  try {
    const response = await API({
      method: "get",
      url: "/api/project/count",
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const getCompletedProjects = async () => {
  try {
    const response = await API({
      method: "get",
      url: "/api/project/all-completed",
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const getActiveProjects = async () => {
  try {
    const response = await API({
      method: "get",
      url: "/api/project/all-active",
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const getCompletedProjectsCount = async () => {
  try {
    const response = await API({
      method: "get",
      url: "/api/project/all-completed-count",
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const projectAddToFavorite = async ({ id }) => {
  try {
    const response = await API({
      method: "post",
      url: `/api/donor/addToFav/${id}`,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};

export const projectRemoveFromFavorite = async ({ id }) => {
  try {
    const response = await API({
      method: "post",
      url: `/api/donor/removeFromFav/${id}`,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
